module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/foto-afe5a66a5fe31345b4b672dea472c0f4.png";